export default function convertTo12Hour(time) {
  if (time != null) {
    const [hourString, minute] = time.split(":");
    let hour = parseInt(hourString, 10);
    const ampm = hour >= 12 ? "pm" : "am";
    hour = hour % 12 || 12; // Convert 0 to 12 for 12 AM
    return `${hour}:${minute}${ampm}`;
  }
}
